import 'normalize.css';
import React from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial,
      sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
    font-variant: tabular-nums;
    line-height: 1.5;
    background-color: #fff;
  }
  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
  }
  p {
    margin-top: 0;
    margin-bottom: 1em;
  }
`;

const NotFound = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
`;

const App = () => {
  return (
    <>
      <GlobalStyle />
      <HashRouter>
        <Switch>
          <Route path="/privacy" component={Privacy} />
          <Route path="/terms" component={Terms} />
          <Route render={() => <NotFound>404</NotFound>} />
        </Switch>
      </HashRouter>
    </>
  );
};

export default App;
